/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { type HttpResponse, I18nService } from '@dm/core';
import { type MappingView } from 'app/common/types/mo';
import { DataTypeId } from 'app/feature/share/global-search/global-infigo/const';
import { type Observable, forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { InfigoService } from '../../../infigo.service';
import { RefreshComponent } from '../../RefreshComponent';
import { MappingTableComponent } from '../../resource-table/mapping-table/mapping-table.component';
import { MemberInitiatorsTableComponent } from '../../resource-table/member-initiators-table/member-initiators-table.component';

@Component({
    selector: 'app-host-resource',
    templateUrl: './host-resource.component.html',
    styleUrls: ['../../resource.scss'],
})
export class HostResourceComponent extends RefreshComponent {
    @Input() data;
    @ViewChild('mappingTable', { static: true }) mappingTable: MappingTableComponent;
    @ViewChild('memberInitiatorsTable', { static: true }) memberInitiatorsTable: MemberInitiatorsTableComponent;
    firstTabItem = this.i18n.get('home.search_term_mappedLUNorGroup_lab');
    secondTabItem = this.i18n.get('host.host_term_initiators_tab');
    defaultActiveItem = this.firstTabItem;
    hostId;
    mappingList: MappingView[] = [];
    initiatorsList = [];
    $destroy = new Subject<void>();
    loading = true;
    propName = 'data';

    constructor(private i18n: I18nService, public infigoService: InfigoService, public changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    requestInfo(): Observable<any> {
        this.hostId = this.data && (this.data.ID || this.data.actionParams);
        return forkJoin([this.getAssociateHostGroup(), this.getMemberInitiators()]);
    }

    handleRequest(value: any): void {
        const [host, initiator] = value;
        this.mappingList = host.data;
        this.initiatorsList = initiator;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }

    // 获取LUN组关联的关联关系 - 主机组
    getAssociateHostGroup(): Observable<HttpResponse> {
        return this.infigoService.getAssociateMappings(DataTypeId[this.data.type], this.hostId)
            .pipe(takeUntil(this.$destroy));
    }

    // 获取主机关联的 启动器
    getMemberInitiators(): Observable<any[]> {
        return this.infigoService.getHostInitiators(this.hostId)
            .pipe(takeUntil(this.$destroy));
    }
}
